(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-zion-carrousel]').forEach(function (carrousel) {
  var piste = carrousel.querySelector('.zion-carrousel__piste');
  var cartes = Array.prototype.slice.call(piste.querySelectorAll('.zion-carte'));
  var gauche = carrousel.querySelector('.zion-carrousel__fleche.gauche');
  var droite = carrousel.querySelector('.zion-carrousel__fleche.droite');
  if (!cartes.length) return;
  var mobile = function () { return window.innerWidth < 700; };
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var rafDemande = false;
  function rendre() {
    rafDemande = false;
    var centre = piste.scrollLeft + piste.clientWidth / 2;
    var scaleMax = mobile() ? 1.2 : 1.34;
    var chute = mobile() ? 0.38 : 0.58;
    var rotMax = mobile() ? 12 : 16;
    var meilleur = null, meilleureDist = Infinity;
    cartes.forEach(function (c) {
      var cc = c.offsetLeft - piste.offsetLeft + c.offsetWidth / 2;
      var d = (cc - centre) / (c.offsetWidth + 26);
      var borne = Math.max(-1, Math.min(1, d));
      var a = Math.abs(borne);
      c.style.transform = 'rotateY(' + (-rotMax * borne).toFixed(2) + 'deg) scale(' + (scaleMax - chute * a).toFixed(3) + ')';
      var extra = Math.max(0, Math.abs(d) - 1.15);
      var op = Math.max(0, (1 - 0.3 * a) * (1 - Math.min(1, extra / 0.55)));
      c.style.opacity = op.toFixed(3);
      c.style.pointerEvents = op < 0.1 ? 'none' : '';
      c.style.zIndex = String(Math.round(10 - 9 * a));
      var dist = Math.abs(cc - centre);
      if (dist < meilleureDist) { meilleureDist = dist; meilleur = c; }
    });
    cartes.forEach(function (c) { c.classList.toggle('est-centre', c === meilleur); });
  }
  var settle = null;
  function planifier() {
    if (!rafDemande) { rafDemande = true; requestAnimationFrame(rendre); }
    if (settle) clearTimeout(settle);
    settle = setTimeout(rendre, 140);
  }
  piste.addEventListener('scroll', planifier, { passive: true });
  window.addEventListener('resize', planifier);
  if (document.readyState === 'complete') rendre();
  else window.addEventListener('load', rendre);
  rendre();

  var pas = function () { return cartes[0].offsetWidth + 26; };

  var downX = null, downScroll = 0, bouge = false;
  piste.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    downX = e.clientX; downScroll = piste.scrollLeft; bouge = false;
    piste.classList.add('en-drag');
    stopAuto();
  });
  window.addEventListener('pointermove', function (e) {
    if (downX === null) return;
    var dx = e.clientX - downX;
    if (Math.abs(dx) > 8) bouge = true;
    piste.scrollLeft = downScroll - dx;
  });
  window.addEventListener('pointerup', function () {
    if (downX === null) return;
    downX = null;
    piste.classList.remove('en-drag');
    relancerAuto();
  });
  piste.addEventListener('click', function (e) {
    if (bouge) { e.preventDefault(); bouge = false; }
  }, true);

  if (gauche) gauche.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); stopAuto(); relancerAuto(); });
  if (droite) droite.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); stopAuto(); relancerAuto(); });

  var timer = null;
  function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
  function relancerAuto() {
    if (reduit) return;
    stopAuto();
    timer = setInterval(function () {
      var fin = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 10;
      if (fin) piste.scrollTo({ left: 0, behavior: 'smooth' });
      else piste.scrollBy({ left: pas(), behavior: 'smooth' });
    }, 5000);
  }
  carrousel.addEventListener('mouseenter', stopAuto);
  carrousel.addEventListener('mouseleave', relancerAuto);
  piste.addEventListener('touchstart', stopAuto, { passive: true });
  piste.addEventListener('touchend', relancerAuto, { passive: true });
  relancerAuto();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-cart-nudge"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-zion-nudge]').forEach(function (zone) {
  var vignettes = Array.prototype.slice.call(zone.querySelectorAll('[data-nudge-vignette]'));
  if (!vignettes.length) return;
  var onglets = Array.prototype.slice.call(zone.querySelectorAll('[data-onglet]'));
  var groupes = Array.prototype.slice.call(zone.querySelectorAll('.zion-nudge__vignettes'));
  var img = zone.querySelector('[data-nudge-img]');
  var nom = zone.querySelector('[data-nudge-nom]');
  var cta = zone.querySelector('[data-nudge-cta]');
  var ctaTexte = zone.querySelector('[data-nudge-cta-texte]');
  var choisi = vignettes[0];

  function maj() {
    vignettes.forEach(function (v) { v.classList.toggle('choisie', v === choisi); });
    if (img) { img.src = choisi.dataset.img; img.alt = choisi.dataset.nom; }
    if (nom) nom.textContent = choisi.dataset.nom;
  }
  onglets.forEach(function (o) {
    o.addEventListener('click', function () {
      onglets.forEach(function (x) { x.classList.toggle('actif', x === o); });
      groupes.forEach(function (g) { g.classList.toggle('cache', g.dataset.groupe !== o.dataset.onglet); });
      var premiere = zone.querySelector('[data-nudge-vignette][data-groupe="' + o.dataset.onglet + '"]');
      if (premiere) { choisi = premiere; maj(); }
    });
  });
  vignettes.forEach(function (v) {
    v.addEventListener('click', function () { choisi = v; maj(); });
  });
  cta.addEventListener('click', function () {
    cta.disabled = true;
    if (ctaTexte) ctaTexte.textContent = 'Ajout en cours…';
    fetch(zone.dataset.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(choisi.dataset.id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      if (ctaTexte) ctaTexte.textContent = 'Ajouté ✓';
      window.location.reload();
    }).catch(function () {
      cta.disabled = false;
      if (ctaTexte) ctaTexte.textContent = 'Réessayer';
    });
  });
  maj();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-collec-filtres]').forEach(function (filtres) {
  var section = filtres.closest('.zion-collec');
  var cartes = section.querySelectorAll('.zion-collec__carte');
  filtres.addEventListener('click', function (e) {
    var chip = e.target.closest('.zion-chip');
    if (!chip) return;
    filtres.querySelectorAll('.zion-chip').forEach(function (c) { c.classList.remove('actif'); });
    chip.classList.add('actif');
    var cible = chip.getAttribute('data-cible');
    cartes.forEach(function (carte) {
      carte.hidden = cible !== 'tous' && carte.getAttribute('data-produit') !== cible;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-duo"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-zion-duo]').forEach(function (zone) {
  var vignettes = Array.prototype.slice.call(zone.querySelectorAll('[data-vignette]'));
  if (vignettes.length < 2) return;
  var slots = Array.prototype.slice.call(zone.querySelectorAll('.zion-duo__paire'));
  var cta = zone.querySelector('[data-duo-cta]');
  var ctaTexte = zone.querySelector('[data-duo-cta-texte]');
  var consigne = zone.querySelector('[data-duo-consigne]');
  var eco = zone.querySelector('[data-duo-eco]');
  var indexPaireDeux = vignettes.findIndex(function (v) { return v.dataset.modele === '2'; });
  if (indexPaireDeux < 0) indexPaireDeux = Math.min(1, vignettes.length - 1);
  var selection = [0, indexPaireDeux];
  var actif = 0;
  var toucheAuxDeux = false;

  function maj(avecSwap, slotChange) {
    slots.forEach(function (slot, s) {
      var v = vignettes[selection[s]];
      var img = slot.querySelector('[data-slot-img]');
      var wrap = slot.querySelector('[data-slot-wrap]');
      img.src = v.dataset.img;
      img.alt = v.dataset.nom;
      slot.querySelector('[data-slot-nom]').textContent = v.dataset.nom;
      slot.classList.toggle('actif', s === actif);
      if (avecSwap && s === slotChange && wrap) {
        wrap.classList.remove('swap');
        void wrap.offsetWidth;
        wrap.classList.add('swap');
      }
    });
    vignettes.forEach(function (v, k) {
      v.classList.toggle('choisie', k === selection[0] || k === selection[1]);
    });
    if (consigne) {
      consigne.textContent = toucheAuxDeux ? 'Ton duo est prêt. Tu peux encore changer chaque paire.' : 'Choisis le coloris de la paire ' + (actif + 1);
    }
    if (avecSwap && eco) {
      eco.classList.remove('pulse');
      void eco.offsetWidth;
      eco.classList.add('pulse');
    }
  }

  vignettes.forEach(function (v, k) {
    v.addEventListener('click', function () {
      var change = actif;
      selection[actif] = k;
      if (actif === 1) toucheAuxDeux = true;
      actif = 1 - actif;
      maj(true, change);
    });
  });
  slots.forEach(function (slot, s) {
    slot.addEventListener('click', function () { actif = s; maj(false, -1); });
  });
  cta.addEventListener('click', function () {
    var a = vignettes[selection[0]].dataset.id;
    var b = vignettes[selection[1]].dataset.id;
    var items = a === b ? [{ id: Number(a), quantity: 2 }] : [{ id: Number(a), quantity: 1 }, { id: Number(b), quantity: 1 }];
    var texteInitial = ctaTexte ? ctaTexte.textContent : '';
    cta.disabled = true;
    if (ctaTexte) ctaTexte.textContent = 'Ajout en cours…';
    if (window.zionAddItems) {
      window.zionAddItems(items, cta).then(function () {
        if (ctaTexte) ctaTexte.textContent = 'Duo ajouté ✓';
        setTimeout(function () {
          cta.disabled = false;
          if (ctaTexte) ctaTexte.textContent = texteInitial;
        }, 2500);
      }).catch(function () {
        window.location.href = zone.dataset.cart + '/' + a + ':1,' + b + ':1';
      });
      return;
    }
    fetch(zone.dataset.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      if (ctaTexte) ctaTexte.textContent = 'Duo ajouté ✓';
      window.location.href = zone.dataset.cart;
    }).catch(function () {
      window.location.href = zone.dataset.cart + '/' + a + ':1,' + b + ':1';
    });
  });
  maj(false, -1);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zion-hero').forEach(function (hero) {
  var bouton = hero.querySelector('[data-zion-pause]');
  var video = hero.querySelector('video');
  if (!video) return;

  // Pause volontaire du visiteur : elle seule empêche la relance automatique.
  var pauseVoulue = false;

  function relancer() {
    if (pauseVoulue || document.hidden || !video.isConnected) return;
    video.muted = true;            // exigé par iOS/Safari avant toute lecture auto
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // La boucle native peut être ignorée quand la source est remplacée à la volée
  video.loop = true;
  video.addEventListener('ended', function () {
    if (pauseVoulue) return;
    try { video.currentTime = 0; } catch (e) {}
    relancer();
  });

  // Un onglet masqué, une mise en veille ou une navigation arrière coupent la lecture
  document.addEventListener('visibilitychange', function () { if (!document.hidden) relancer(); });
  window.addEventListener('pageshow', relancer);
  video.addEventListener('canplay', relancer);
  video.addEventListener('loadeddata', relancer);
  video.addEventListener('stalled', relancer);
  video.addEventListener('suspend', relancer);

  // Certains navigateurs refusent la lecture auto : on repart au premier geste
  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, relancer, { once: true, passive: true });
  });

  // Hors de l'écran, on laisse le navigateur souffler ; de retour, on relance
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) relancer(); });
    }, { threshold: 0.15 }).observe(hero);
  }

  relancer();

  if (!bouton) return;
  function refletBouton() {
    var enPause = video.paused;
    bouton.querySelector('[data-ico-pause]').hidden = enPause;
    bouton.querySelector('[data-ico-play]').hidden = !enPause;
    bouton.setAttribute('aria-label', enPause ? 'Lancer la vidéo' : 'Mettre la vidéo en pause');
  }
  bouton.addEventListener('click', function () {
    if (video.paused) { pauseVoulue = false; relancer(); }
    else { pauseVoulue = true; video.pause(); }
    refletBouton();
  });
  video.addEventListener('play', refletBouton);
  video.addEventListener('pause', refletBouton);
  refletBouton();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-polarise"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-zion-compare]').forEach(function (bloc) {
  var dessus = bloc.querySelector('[data-zion-dessus]');
  var ligne = bloc.querySelector('[data-zion-ligne]');
  var range = bloc.querySelector('[data-zion-range]');
  if (!dessus) return;

  var valeur = 50;
  function appliquer(v) {
    valeur = Math.max(0, Math.min(100, v));
    dessus.style.clipPath = 'inset(0 0 0 ' + valeur + '%)';
    if (ligne) ligne.style.left = valeur + '%';
    if (range) range.value = valeur;
  }
  function depuisX(clientX) {
    var r = bloc.getBoundingClientRect();
    if (!r.width) return valeur;
    return ((clientX - r.left) / r.width) * 100;
  }
  appliquer(50);

  // Le curseur suit exactement le doigt ou la souris, sans passer par le champ natif
  // (le champ décalait la position de la largeur de sa poignée).
  var actif = false, decide = false, idPointeur = null, departX = 0, departY = 0;

  bloc.addEventListener('pointerdown', function (e) {
    if (e.button !== undefined && e.button !== 0) return;
    idPointeur = e.pointerId;
    departX = e.clientX; departY = e.clientY;
    if (e.pointerType === 'touch') {
      // On laisse le doigt décider : glissement horizontal = comparateur,
      // vertical = défilement de la page. Rien n'est capturé tant que ce n'est pas tranché.
      actif = false; decide = false;
    } else {
      actif = true; decide = true;
      try { bloc.setPointerCapture(e.pointerId); } catch (err) {}
      appliquer(depuisX(e.clientX));
      e.preventDefault();
    }
    if (range) { try { range.focus({ preventScroll: true }); } catch (err) {} }
  });

  bloc.addEventListener('pointermove', function (e) {
    if (idPointeur === null || e.pointerId !== idPointeur) return;
    if (!decide) {
      var dx = Math.abs(e.clientX - departX);
      var dy = Math.abs(e.clientY - departY);
      if (dx < 6 && dy < 6) return;          // geste encore trop court pour trancher
      decide = true;
      if (dx <= dy) { idPointeur = null; return; }   // c'est un défilement, on se retire
      actif = true;
      try { bloc.setPointerCapture(e.pointerId); } catch (err) {}
    }
    if (!actif) return;
    appliquer(depuisX(e.clientX));
    e.preventDefault();
  }, { passive: false });

  function relacher(e) {
    if (idPointeur === null || (e && e.pointerId !== undefined && e.pointerId !== idPointeur)) return;
    // Appui bref sans glissement : on place quand même le curseur sous le doigt
    if (!actif && e && Math.abs(e.clientX - departX) < 6 && Math.abs(e.clientY - departY) < 6) {
      appliquer(depuisX(e.clientX));
    }
    try { bloc.releasePointerCapture(idPointeur); } catch (err) {}
    idPointeur = null; actif = false; decide = false;
  }
  bloc.addEventListener('pointerup', relacher);
  bloc.addEventListener('pointercancel', relacher);

  // Le champ natif reste là pour le clavier et les lecteurs d'écran
  if (range) range.addEventListener('input', function () { appliquer(parseFloat(range.value)); });

  // Les deux vues doivent être arrivées avant de révéler le comparateur
  var photos = Array.prototype.slice.call(bloc.querySelectorAll('[data-zion-photo]'));
  var restantes = photos.length;
  function pretes() { bloc.classList.add('est-prete'); }
  if (!restantes) pretes();
  photos.forEach(function (img) {
    var vue = function () { restantes -= 1; if (restantes <= 0) pretes(); };
    if (img.complete && img.naturalWidth) vue();
    else {
      img.addEventListener('load', vue, { once: true });
      img.addEventListener('error', vue, { once: true });
    }
  });
  setTimeout(pretes, 6000); // filet de sécurité : jamais de cadre vide

  // Petite invitation : la ligne oscille une fois au premier affichage
  var anime = false;
  var obs = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (!e.isIntersecting || anime) return;
      anime = true;
      var t0 = null;
      function osciller(t) {
        if (actif) { appliquer(valeur); return; }   // le visiteur a pris la main
        if (!t0) t0 = t;
        var p = (t - t0) / 1600;
        if (p >= 1) { appliquer(50); return; }
        appliquer(50 + Math.sin(p * Math.PI * 2) * 14 * (1 - p));
        requestAnimationFrame(osciller);
      }
      requestAnimationFrame(osciller);
      obs.disconnect();
    });
  }, { threshold: 0.5 });
  obs.observe(bloc);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-product"]) return;
  try {
    
document.querySelectorAll('[data-zion-fiche]').forEach(function (fiche) {
  var vignettes = Array.prototype.slice.call(fiche.querySelectorAll('[data-fiche-vignette]'));
  var img = fiche.querySelector('[data-fiche-img]');
  var rangee = fiche.querySelector('[data-fiche-angles]');

  function afficher(url, alt) {
    if (!img) return;
    img.src = url;
    if (alt) img.alt = alt;
  }

  function activer(bouton) {
    if (!rangee) return;
    rangee.querySelectorAll('[data-fiche-angle]').forEach(function (b) { b.classList.remove('choisi'); });
    bouton.classList.add('choisi');
  }

  function brancherAngles() {
    if (!rangee) return;
    rangee.querySelectorAll('[data-fiche-angle]').forEach(function (b) {
      b.addEventListener('click', function () {
        activer(b);
        afficher(b.dataset.img, b.getAttribute('aria-label'));
      });
    });
  }

  function angleActif() {
    if (!rangee) return 0;
    var boutons = Array.prototype.slice.call(rangee.querySelectorAll('[data-fiche-angle]'));
    var i = boutons.findIndex(function (b) { return b.classList.contains('choisi'); });
    return i < 0 ? 0 : i;
  }

  function poserAngles(vues, alts, garde) {
    if (!rangee || !vues) return null;
    var urls = vues.split('|');
    var libelles = (alts || '').split('|');
    // on reste sur le meme angle en changeant de coloris : la comparaison est plus lisible
    var actif = garde < urls.length ? garde : 0;
    rangee.innerHTML = urls.map(function (url, i) {
      var alt = (libelles[i] || '').replace(/"/g, '&quot;');
      return '<button type="button" class="zion-angle' + (i === actif ? ' choisi' : '') + '" data-fiche-angle' +
             ' data-img="' + url + '" aria-label="' + alt + '">' +
             '<img src="' + url.replace('width=1400', 'width=240') + '" alt="" loading="lazy"></button>';
    }).join('');
    brancherAngles();
    return { url: urls[actif], alt: libelles[actif] };
  }

  brancherAngles();
  var nom = fiche.querySelector('[data-fiche-nom]');
  var champId = fiche.querySelector('[data-fiche-id]');
  var cta = fiche.querySelector('[data-fiche-cta]');
  var prixEls = [fiche.querySelector('[data-fiche-prix]'), fiche.querySelector('[data-fiche-prix-cta]'), fiche.querySelector('[data-fiche-prix-sticky]')];
  var stickyNom = fiche.querySelector('[data-fiche-sticky-nom]');
  vignettes.forEach(function (v) {
    v.addEventListener('click', function () {
      vignettes.forEach(function (x) { x.classList.remove('choisie'); });
      v.classList.add('choisie');
      var vue = poserAngles(v.dataset.vues, v.dataset.vuesAlt, angleActif());
      afficher(vue ? vue.url : v.dataset.img, vue ? vue.alt : v.dataset.nom);
      if (nom) nom.textContent = v.dataset.nom;
      if (stickyNom) stickyNom.textContent = v.dataset.nom;
      if (champId) champId.value = v.dataset.id;
      prixEls.forEach(function (p) { if (p) p.textContent = v.dataset.prix; });
      var dispo = v.dataset.dispo === 'true';
      if (cta) cta.disabled = !dispo;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.dataset.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });
  var sticky = fiche.querySelector('[data-fiche-sticky]');
  var stickyCta = fiche.querySelector('[data-fiche-sticky-cta]');
  if (sticky && cta) {
    var obs = new IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting;
    }, { threshold: 0 });
    obs.observe(cta);
    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        cta.closest('form').requestSubmit();
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-shopable"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-zion-shop-tuile]').forEach(function (tuile) {
  var pastilles = Array.prototype.slice.call(tuile.querySelectorAll('[data-shop-pastille]'));
  var ajout = tuile.querySelector('[data-shop-ajout]');
  var ajoutTexte = tuile.querySelector('[data-shop-ajout-texte]');
  var vignette = tuile.querySelector('[data-shop-vignette]');
  var coloris = tuile.querySelector('[data-shop-coloris]');
  var prix = tuile.querySelector('[data-shop-prix]');
  var fiche = tuile.querySelector('[data-shop-fiche]');
  var point = tuile.querySelector('[data-shop-point]');
  var pointPrix = tuile.querySelector('[data-shop-point-prix]');
  var erreur = tuile.querySelector('[data-shop-erreur]');
  if (!ajout) return;
  /* Le libellé disponible ne doit pas dépendre du stock de la variante initiale. */
  var libelle = ajout.dataset.shopLibelle || 'Ajouter au panier';
  var minuteur = null;

  function choisir(pastille) {
    pastilles.forEach(function (p) {
      var actif = p === pastille;
      p.classList.toggle('actif', actif);
      p.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
    if (vignette && pastille.dataset.img) {
      vignette.style.opacity = '0';
      var image = new Image();
      image.onload = function () { vignette.src = pastille.dataset.img; vignette.style.opacity = ''; };
      image.onerror = function () { vignette.style.opacity = ''; };
      image.src = pastille.dataset.img;
    }
    if (coloris) coloris.textContent = pastille.dataset.nom;
    if (prix) prix.textContent = pastille.dataset.prix;
    if (pointPrix) pointPrix.textContent = pastille.dataset.prix;
    if (fiche) fiche.href = pastille.dataset.url;
    if (point) point.href = pastille.dataset.url;
    if (erreur) erreur.hidden = true;
    ajout.dataset.id = pastille.dataset.id;
    var dispo = pastille.dataset.dispo !== '0';
    ajout.disabled = !dispo;
    if (ajoutTexte) ajoutTexte.textContent = dispo ? libelle : 'Rupture de stock';
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }
  }

  pastilles.forEach(function (pastille) {
    pastille.addEventListener('click', function () { choisir(pastille); });
  });

  ajout.addEventListener('click', function () {
    var id = Number(ajout.dataset.id);
    if (!id || ajout.disabled) return;
    var items = [{ id: id, quantity: 1 }];
    ajout.disabled = true;
    ajout.setAttribute('aria-busy', 'true');
    if (erreur) erreur.hidden = true;
    if (ajoutTexte) ajoutTexte.textContent = 'Ajout en cours…';

    function reussite() {
      ajout.removeAttribute('aria-busy');
      if (ajoutTexte) ajoutTexte.textContent = 'Ajouté au panier ✓';
      minuteur = setTimeout(function () {
        ajout.disabled = false;
        if (ajoutTexte) ajoutTexte.textContent = libelle;
      }, 2500);
    }

    if (window.zionAddItems) {
      window.zionAddItems(items, ajout).then(reussite).catch(function (e) {
        ajout.removeAttribute('aria-busy');
        if (e && e.zionCartError && erreur) {
          ajout.disabled = false;
          if (ajoutTexte) ajoutTexte.textContent = libelle;
          erreur.textContent = e.message;
          erreur.hidden = false;
          return;
        }
        /* panne réseau ou JS : on ne bloque jamais l'achat */
        window.location.href = tuile.dataset.cart + '/' + id + ':1';
      });
      return;
    }

    fetch(tuile.dataset.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = tuile.dataset.cart;
    }).catch(function () {
      window.location.href = tuile.dataset.cart + '/' + id + ':1';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zion-video-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zion-video-banner').forEach(function (bloc) {
  var bouton = bloc.querySelector('[data-zion-pause]');
  var video = bloc.querySelector('video');
  if (!bouton || !video) return;
  bouton.addEventListener('click', function () {
    var enLecture = !video.paused;
    if (enLecture) { video.pause(); } else { video.play(); }
    bouton.querySelector('[data-ico-pause]').hidden = enLecture;
    bouton.querySelector('[data-ico-play]').hidden = !enLecture;
    bouton.setAttribute('aria-label', enLecture ? 'Lancer la vidéo' : 'Mettre la vidéo en pause');
  });
});

  } catch(e) { console.error(e); }
})();
})();
